export const STOCK_UNITS = ['Unit', 'Milliliter', 'Gram'];

export const STOCK_ADJUSTMENT_REASONS = [
  'CountCorrection',
  'Damaged',
  'Expired',
  'InternalUse',
  'Lost',
  'ReturnedToSupplier',
  'Other',
];

export const STOCK_MOVEMENT_TYPES = [
  'OpeningBalance',
  'Purchase',
  'PurchaseVoid',
  'Sale',
  'SaleVoid',
  'ServiceConsumption',
  'ServiceConsumptionReversal',
  'Adjustment',
];

export const STOCK_PAGE_SIZE = 20;

export default STOCK_UNITS;
